import { render, staticRenderFns } from "./StoreQc.vue?vue&type=template&id=f0068150&lang=pug&"
import script from "./StoreQc.vue?vue&type=script&lang=ts&"
export * from "./StoreQc.vue?vue&type=script&lang=ts&"
import style0 from "./StoreQc.vue?vue&type=style&index=0&id=f0068150&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports